/**
 * 端外登录
 */
import React, { useState } from 'react';
import msdkUtil from 'lib/utils/MSDK';
import session from 'lib/utils/session';
import { showModal } from 'lib/components/Modal';
import ThirdPartyLogin from 'lib/components/ThirdPartyLogin';
import { ACCOUNT_TYPE } from 'lib/constants/login';
import { useFinishInit } from 'lib/hooks/useFinishInit';
import { ComponentProps } from 'types';
import './index.scss';

interface UserInfo {
  nickName?: string;
  token?: string;
  loginType?: string;
}

const QQAndWXLogin = ({ commonStyle, style }: ComponentProps<Record<string, never>>) => {
  const { btnTextColor } = style;
  const [userInfo, setUserInfo] = useState<UserInfo>(session.getSessionData());
  const [isShow, setIsShow] = useState(false);

  useFinishInit(() => {
    setIsShow(!msdkUtil.isMSDK);
  });

  const loginAction = () => {
    if (userInfo.token) {
      goLogout();
      return;
    }

    goLogin();
  };

  const goLogout = () => {
    setUserInfo({});
    session.logout();
  };

  const goLogin = () => {
    showModal(<ThirdPartyLogin />);
  };

  if (!isShow) return null;
  return (
    <div onClick={loginAction} className="login-content" style={{ ...commonStyle }}>
      <div className="login-content__text">
        {userInfo?.token ? `欢迎，${ACCOUNT_TYPE[userInfo?.loginType || '']}用户：${userInfo?.nickName}` : '你好，请'}
      </div>

      <div className="login-content__btn" style={{ color: btnTextColor }}>
        {userInfo?.token ? '【注销】' : '【登录】'}
      </div>
    </div>
  );
};

export default QQAndWXLogin;
